import React from 'react';

import { FaIcon } from '@innovationnorway/component-library';
import { icon } from '@fortawesome/fontawesome-svg-core';
import { IconLookup } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';

interface SubHeaderProps {
  iconDefiniton: IconLookup;
  title: string;
}

const CustomerFollowUp: React.FC = () => {
  const { t: tHelpAndSupport } = useTranslation('onboarding');

  const SubHeader = ({ iconDefiniton, title }: SubHeaderProps) => {
    return (
      <div className="display--flex gap--1 align-items--flex-start">
        <FaIcon icon={icon(iconDefiniton)} />
        <span className="font-weight--bold">{title}</span>
      </div>
    );
  };

  return (
    <div className="stack-large">
      <h2>{tHelpAndSupport('commonQuestions.CustomerFollowUp')}</h2>
      <p>{tHelpAndSupport('commonQuestions.CustomerFollowUp.p')}</p>
      <div className="stack-medium">
        <SubHeader
          iconDefiniton={{ prefix: 'fal', iconName: 'hand-holding-box' }}
          title={tHelpAndSupport('commonQuestions.CustomerFollowUp.RecommendOwnServices')}
        />
        <p>{tHelpAndSupport('commonQuestions.CustomerFollowUp.RecommendOwnServices.p')}</p>
      </div>
      <div className="stack-medium">
        <SubHeader
          iconDefiniton={{ prefix: 'fal', iconName: 'hand-holding-box' }}
          title={tHelpAndSupport('commonQuestions.CustomerFollowUp.RecommendedServices')}
        />
        <p>{tHelpAndSupport('commonQuestions.CustomerFollowUp.RecommendedServices.p1')}</p>
        <ul>
          <li>{tHelpAndSupport('commonQuestions.CustomerFollowUp.RecommendedServices.li1')}</li>
        </ul>
        <p>{tHelpAndSupport('commonQuestions.CustomerFollowUp.RecommendedServices.p2')}</p>
      </div>
      <div className="stack-medium">
        <SubHeader
          iconDefiniton={{ prefix: 'fal', iconName: 'grid-2-plus' }}
          title={tHelpAndSupport('commonQuestions.CustomerFollowUp.DeliveredServices')}
        />
        <p>{tHelpAndSupport('commonQuestions.CustomerFollowUp.DeliveredServices.p')}</p>
      </div>
      <div className="stack-medium">
        <SubHeader
          iconDefiniton={{ prefix: 'fal', iconName: 'sticky-note' }}
          title={tHelpAndSupport('commonQuestions.CustomerFollowUp.AddNote')}
        />
        <p>{tHelpAndSupport('commonQuestions.CustomerFollowUp.AddNote.p1')}</p>
        <ul>
          <li>{tHelpAndSupport('commonQuestions.CustomerFollowUp.AddNote.li1')}</li>
          <li>{tHelpAndSupport('commonQuestions.CustomerFollowUp.AddNote.li2')}</li>
          <li>{tHelpAndSupport('commonQuestions.CustomerFollowUp.AddNote.li3')}</li>
        </ul>
        <p>{tHelpAndSupport('commonQuestions.CustomerFollowUp.AddNote.p2')}</p>
      </div>
    </div>
  );
};

export default CustomerFollowUp;
